import type { LucideIcon } from 'lucide-react';

export interface IconProps {
  icon: LucideIcon;
  /** px. Icons support labels (DESIGN.md), so 16 inline, 20 default, 24 in empty states. */
  size?: 16 | 20 | 24;
  /** Set only when the icon stands alone and has no visible text; otherwise it is decorative. */
  label?: string;
  /** Solid glyph, for a toggled state such as a starred item. */
  filled?: boolean;
}

/** One size scale and one stroke weight for every icon in the product. */
export function Icon({ icon: Glyph, size = 20, label, filled }: IconProps) {
  return (
    <Glyph
      size={size}
      strokeWidth={1.75}
      absoluteStrokeWidth
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable={false}
      fill={filled ? 'currentColor' : 'none'}
    />
  );
}
